//
//
//
//
//
//
//
//

import listArrange from '@/components/temporary/list-arrange'
import divSpan from '@/components/DivSpan';
import listHeaderTemplate from '@/components/list-template/list-header-template';
export default {
  name: "claimTp",
  data() {
    return {
      listHeaderTemplateBoard: {},
      listArrange: [],
      approvalTemplateBoard: {}
    }
  },
  props: ['data','tabIndex'],
  created() {
    let templateData = this.data;
    this.listHeaderTemplateBoard = {
      template: listHeaderTemplate.contractQueryV2,
      data() {
        return {
          title: [templateData.claim.docNo],
          desc: []
        }
      }
    };
      this.listArrange = [
        {
          icon: "fa fa-file-text-o font-size-mr",
          span: 10,
          templateBoard: {
            template: listHeaderTemplate.claimScType,
            data() {
              return {
                status: templateData.scType,
              }
            }
          }
        },
        {
          icon: "fa fa-file-text-o font-size-mr",
          span: 8,
          display: templateData.planCycleFrom,
          templateBoard: {
            template: "<span class=\"black opacity7\"> {{claimAmount}} RMB</span>",
            data() {
              return {
                claimAmount: templateData.claimAmount,
              }
            }
          }
        },
      ];
    this.approvalTemplateBoard={
      template: `  <div class="approval_block" >
                    <span class="bg_default" v-if="data.isStartNode">草稿</span>
                    <span class="bg_default" v-else-if="data.isEndNode">
                      <badge class="success"></badge>
                      审批完成
                    </span>
                    <span v-else>
                      <badge class="going"></badge>
                      审批中
                    </span>
                    </div>`,
      data() {
        return {
          data: templateData.claim
        }
      }
    }
  },
  methods: {},
  components: {
    listArrange,
    divSpan,
    listHeaderTemplate
  }
}



// WEBPACK FOOTER //
// ./src/components/page-temporary/claimTp.vue